module.exports = __webpack_public_path__ + "img/improve.55bb44a.svg";